<template>
  <v-dialog :value="value" @input="$emit('input', $event)" no-click-animation persistent scrollable width="960">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{title}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="close" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-divider />

      <v-stepper v-model="step" flat style="min-height: 70px;">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="step > 1" step="1">Archivo</v-stepper-step>
          <v-divider />
          <v-stepper-step step="2">Datos</v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <v-divider />

      <v-card-text class="pa-0 background-card">
        <v-window v-model="step" touchless>
          <v-window-item :value="1">
            <div class="pa-6">
              <v-alert v-if="submissionRequest" class="mb-4" dense text type="info">
                Vinculando con la solicitud enviada a {{newImport.customer && newImport.customer.name}} el {{submissionRequest.sent_at | date}}
              </v-alert>
              <pdf-inline-preview v-model="newImport.file" height="520" />
              <v-row v-if="newImport.file" no-gutters align="center" class="mt-4">
                <v-chip class="mr-2" label outlined>
                  <v-icon left small>mdi-file-pdf-box</v-icon>
                  {{ newImport.file.name }}
                  <span class="ml-2 text--secondary">{{ fileSize }}</span>
                </v-chip>
                <v-btn @click="clearFile" text small color="secondary"><v-icon left small>mdi-close</v-icon>Quitar</v-btn>
              </v-row>
            </div>
          </v-window-item>
          <v-window-item :value="2">
            <v-row no-gutters>
              <v-col cols="5" class="pa-4">
                <pdf-inline-preview :file="newImport.file" disabled height="600" />
                <v-row no-gutters align="center" class="mt-3">
                  <v-btn @click="backToFile" outlined small color="secondary"><v-icon left small>mdi-swap-horizontal</v-icon>Cambiar archivo</v-btn>
                  <v-spacer />
                  <span v-if="newImport.file" class="caption text--secondary">{{ fileSize }}</span>
                </v-row>
              </v-col>

              <v-divider vertical />

              <v-col>
                <v-list class="py-6 transparent">
                  <v-alert v-if="submissionRequest" class="mx-4 mb-2" dense text type="info">
                    Vinculando con la solicitud enviada a {{newImport.customer && newImport.customer.name}} el {{submissionRequest.sent_at | date}}
                  </v-alert>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Cliente</v-list-item-title>
                      <v-list-item-subtitle class="pl-1" v-if="!newImport.customer || !newImport.customer.id">
                        <v-col cols="10" class="py-1 px-0">
                          <v-btn @click="dialogCustomer=true" outlined :ripple="false" :disabled="customerLocked"><v-icon left>mdi-plus</v-icon>Seleccionar un cliente</v-btn>
                        </v-col>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-else>
                        <v-row no-gutters align="center" class="py-1">
                          <v-col cols="7">
                            <span class="body-2 text--secondary font-weight-medium">{{newImport.customer.name}}</span>
                          </v-col>
                          <v-col cols="5" class="pl-2">
                            <v-btn v-if="!customerLocked" @click="dialogCustomer=true" outlined color="secondary">Cambiar...</v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Tipo de documento</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="8" class="py-1 px-0">
                          <v-select v-model="$v.newImport.document_type.$model" :error="$v.newImport.document_type.$error" :items="supportingDocumentTypes" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Número o identificador</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="6" class="py-1 px-0">
                          <v-text-field v-model.trim="$v.newImport.serial.$model" :error="$v.newImport.serial.$error" maxlength="64" background-color="white" outlined required single-line dense hide-details />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Descripción</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="10" class="py-1 px-0">
                          <v-text-field v-model.trim="newImport.description" maxlength="128" background-color="white" outlined single-line dense hide-details />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Fecha</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="6" class="py-1 px-0">
                          <v-menu v-model="datePickers.dateIssued" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="$v.newImport.date_issued.$model" :error="$v.newImport.date_issued.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                                <template v-slot:append>
                                  <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="$v.newImport.date_issued.$model" @input="datePickers.dateIssued=false" type="date" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title>
                              <v-row class="py-2 px-6" align="center" justify="end">
                                <v-btn @click="() => { $v.newImport.date_issued.$model=today; datePickers.dateIssued=false }" color="primary">Hoy</v-btn>
                              </v-row>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary font-weight-medium">Válido hasta</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="6" class="py-1 px-0">
                          <v-menu v-model="datePickers.validUntil" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="$v.newImport.valid_until.$model" :error="$v.newImport.valid_until.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                                <template v-slot:append>
                                  <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="$v.newImport.valid_until.$model" @input="datePickers.validUntil=false" type="date" :min="today" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title>
                              <v-row class="py-2 px-6" align="center" justify="end">
                                <v-btn @click="() => { $v.newImport.valid_until.$model=today; datePickers.validUntil=false }" color="primary">Hoy</v-btn>
                              </v-row>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn @click="close" outlined>Cancelar</v-btn>
        <v-spacer />
        <template v-if="step === 1">
          <v-btn @click="goToForm" :disabled="!canProceed" color="primary">Siguiente</v-btn>
        </template>
        <template v-else>
          <v-btn @click="backToFile" class="mr-2" outlined><v-icon left small>mdi-arrow-left</v-icon>Atrás</v-btn>
          <v-btn @click="createImport" :loading="$store.state.supportingDocuments.createLoader" color="primary">{{submissionRequest ? 'Registrar OC' : 'Importar'}}</v-btn>
        </template>
      </v-card-actions>
    </v-card>

    <customer-picker-dialog v-model="dialogCustomer" @select="setCustomer" />
  </v-dialog>
</template>
<script>
import { maxLength, required } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import CustomerPickerDialog from '@/components/supporting-documents/CustomerPickerDialog'
import PdfInlinePreview from '@/components/supporting-documents/PdfInlinePreview'

const defaultForm = () => ({
  customer: null,
  date_issued: '',
  description: '',
  document_type: '',
  file: null,
  serial: '',
  valid_until: null
})

export default {
  components: {
    CustomerPickerDialog,
    PdfInlinePreview
  },
  mixins: [
    GenericViewMixin
  ],
  props: {
    submissionRequest: {
      type: Object,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialogCustomer: false,
    datePickers: {
      dateIssued: false,
      validUntil: false
    },
    newImport: defaultForm(),
    step: 1,
    supportingDocumentTypes: [
      { id: '801', name: 'Orden de compra' },
      { id: '802', name: 'Contrato' }
    ]
  }),
  computed: {
    canProceed () {
      return !!this.newImport.file
    },
    customerLocked () {
      return !!this.submissionRequest
    },
    fileSize () {
      if (!this.newImport.file) return ''
      const bytes = this.newImport.file.size
      if (bytes < 1024) return `${bytes} B`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
      return `${(bytes / 1024 / 1024).toFixed(1)} MB`
    },
    title () {
      return this.submissionRequest ? 'Registrar OC recibida' : 'Importar documento de soporte'
    },
    today () {
      return new Date().toISOString().slice(0, 10)
    }
  },
  watch: {
    value (open) {
      if (open) this.reset()
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    reset () {
      this.newImport = defaultForm()
      this.step = 1
      this.$v.$reset()

      if (this.submissionRequest) {
        this.newImport.customer = {
          id: this.submissionRequest.customer,
          name: this.submissionRequest.customer_name
        }
        if (this.submissionRequest.submission_type === 'order') {
          this.newImport.document_type = '801'
        }
      }
    },
    clearFile () {
      this.newImport.file = null
    },
    goToForm () {
      if (!this.newImport.file) return
      this.step = 2
    },
    backToFile () {
      this.step = 1
    },
    createImport () {
      this.$v.newImport.$touch()

      if (this.$v.newImport.$invalid) return false

      const payload = new FormData()
      payload.append('customer', this.newImport.customer.id)
      payload.append('document_type', this.newImport.document_type)
      payload.append('date_issued', this.newImport.date_issued)
      payload.append('file', this.newImport.file)
      payload.append('serial', this.newImport.serial)
      payload.append('valid_until', this.newImport.valid_until)
      if (this.newImport.description) {
        payload.append('description', this.newImport.description)
      }
      if (this.submissionRequest) {
        payload.append('submission_request', this.submissionRequest.id)
      }

      this.$store.dispatch('supportingDocuments/CREATE', {
        resource: 'supporting-documents/documents',
        payload: payload,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        this.$dialog.message.success(this.submissionRequest ? 'OC registrada correctamente' : 'Documento importado correctamente')
        this.$emit('created', response.data)
        this.close()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    setCustomer (customer) {
      this.newImport.customer = customer
    }
  },
  validations: {
    newImport: {
      customer: { required },
      date_issued: { required },
      document_type: { required, maxLength: maxLength(64) },
      file: { required },
      serial: { required, maxLength: maxLength(64) },
      valid_until: { required }
    }
  }
}
</script>
